import React from 'react';
import { Gift, Zap, Crown, Heart, Users } from 'lucide-react';
const bonuses = [{
  title: 'KIT EXPRESS DI ADATTAMENTI IMMEDIATI™',
  description: 'Adatta qualsiasi sequenza in 2 minuti per principianti, senior o allievi con limitazioni senza improvvisare e senza rifare la classe da zero.'
}, {
  title: 'BANCA DI INTRO E CHIUSURE PRONTE™',
  description: '50 introduzioni e cierres professionali pronti da usare per aprire e chiudere ogni classe con presenza, autorità e fluidità naturale.'
}, {
  title: "PLANNER SETTIMANALE DELL'INSEGNANTE YOGA™",
  description: "Il sistema di pianificazione visiva per organizzare tutta la settimana di classi in 10 minuti senza ripetizioni e senza improvvisazione dell'ultimo momento."
}, {
  title: 'CHECKLIST PRE-CLASSE PROFESSIONALE™',
  description: 'La routine operativa di 3 minuti per entrare in ogni classe con spazio, materiali, allievi e obiettivo completamente sotto controllo.'
}, {
  title: 'MATRICE DI SCELTA RAPIDA DELLA LEZIONE™',
  description: 'Scegli la sequenza ideale per ogni gruppo in meno di 60 secondi usando una matrice visiva basata su livello, energia, obiettivo e tempo disponibile.'
}];
export function BonusSection() {
  return <>
      <section className="py-16 px-4 bg-brand-light border-b-8 border-brand-gold" data-id="element-14">
        <div className="max-w-5xl mx-auto" data-id="element-15">
          <div className="text-center mb-12" data-id="element-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-dark mb-4 tracking-tight uppercase" data-id="element-17">
              5 BONUS PREMIUM INCLUSI
            </h2>
            <p className="text-base sm:text-lg text-brand-dark font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-18">
              Riceverai anche 5 bonus premium progettati per farti risparmiare
              ancora più tempo e aiutare i tuoi allievi a ottenere risultati
              migliori.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-19">
            {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold p-6 rounded-xl text-center shadow-xl hover:shadow-2xl transition-shadow" data-id="element-20">
                <div className="w-16 h-16 mx-auto bg-brand-gold/20 rounded-full flex items-center justify-center mb-4 border-2 border-brand-gold/50" data-id="element-21">
                  <Gift className="w-8 h-8 text-brand-dark" data-id="element-22" />
                </div>
                <p className="text-xs font-black text-brand-red mb-2 tracking-widest uppercase" data-id="element-23">
                  🎁 BONUS {i + 1}
                </p>
                <h3 className="text-base sm:text-lg font-black text-brand-dark mb-3 leading-tight uppercase" data-id="element-24">
                  {bonus.title}
                </h3>
                <p className="text-sm text-brand-dark/80 font-medium leading-relaxed" data-id="element-25">
                  {bonus.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white border-b-8 border-brand-light" data-id="element-26">
        <div className="max-w-4xl mx-auto" data-id="element-27">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-center text-brand-dark mb-12 tracking-tight uppercase" data-id="element-28">
            COSA CAMBIERÀ
          </h2>

          <div className="grid sm:grid-cols-2 gap-6" data-id="element-29">
            {[{
            icon: <Zap className="w-8 h-8 text-brand-accent" data-id="element-30" />,
            title: 'Risparmia Ore Ogni Settimana',
            desc: 'Smetti di creare sequenze da zero. Apri il sistema, scegli il framework e inizia a insegnare immediatamente.'
          }, {
            icon: <Crown className="w-8 h-8 text-brand-accent" data-id="element-31" />,
            title: 'Maggiore Fiducia nel Coaching',
            desc: 'Saprai esattamente cosa insegnare, quando far progredire gli allievi e come strutturare i programmi per ottenere risultati reali.'
          }, {
            icon: <Heart className="w-8 h-8 text-brand-accent" data-id="element-32" />,
            title: 'Risultati Migliori per gli Allievi',
            desc: 'Offri sistemi di pratica strutturati che migliorano la postura, la mobilità, la costanza e la trasformazione corporea.'
          }, {
            icon: <Users className="w-8 h-8 text-brand-accent" data-id="element-33" />,
            title: 'Maggiore Fidelizzazione degli Allievi',
            desc: 'Mantieni i tuoi allievi motivati attraverso progressioni chiare, sistemi di coaching professionali e miglioramenti visibili nel tempo.'
          }].map((item, i) => <div key={i} className="bg-brand-light border-l-8 border-brand-accent p-6 sm:p-8 rounded-r-xl shadow-lg flex gap-5 items-start" data-id="element-34">
                <div className="bg-white p-3 rounded-full shadow-md shrink-0" data-id="element-35">
                  {item.icon}
                </div>
                <div data-id="element-36">
                  <h3 className="text-lg sm:text-xl font-black text-brand-dark mb-2 uppercase" data-id="element-37">
                    {item.title}
                  </h3>
                  <p className="text-brand-dark/80 text-sm sm:text-base font-medium leading-relaxed" data-id="element-38">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}